/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.changePassword.controllers', [
  'ui.router'
])

.controller('ChangePasswordController', ['$scope', '$state', function($scope, $state) {


    $scope.changePassword = {

      isLoading: false,

      isComplete: false,

      showErrors: false,

      email: '',

      errors: [],

      hasErrors: function() {
        return (this.errors.length > 0);
      },

      getToken: function() {

        var token = false;

        if ($state.params && $state.params.hasOwnProperty('token')) {
          token = $state.params.token;
        }

        return this.token = token;

      },

      complete: function() {

        $scope.isLoading = true;

        if (ValidateService.validate([
          { password: this.password },
          { password: this.confirmPassword },
          { equal: [ this.password, this.confirmPassword ] }
        ])) {
          this.showErrors = false;
          ApiService.user.changePassword(this.password, this.getToken()).then(this.success, this.error);
        }else{
          this.showErrors = true;
          this.errors = ValidateService.errors;
        }
      },

      success: function(data, status, headers, config) {
        $scope.changePassword.showErrors = false;
        $scope.changePassword.isLoading = false;
        $scope.changePassword.isComplete = true;
      },

      error: function(data, status, headers, config) {
        $scope.changePassword.isLoading = false;
        $scope.changePassword.isComplete = false;
      }

    };

}]);